import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, iif, Observable, of } from 'rxjs';
import { map, mergeMap, take, tap } from 'rxjs/operators';

import { AuthStore } from '@store';

@Injectable()
export class NotAuthGuardService {
  constructor(private authStore: AuthStore, private router: Router) {}

  canActivateChild(): Observable<boolean> {
    return this.checkAuth();
  }

  canActivate(): Observable<boolean> {
    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean> {
    const authenticated$ = combineLatest([
      this.authStore.isRsaUser().pipe(take(1)),
      this.authStore.isEndUserWithoutAccess$.pipe(take(1)),
    ]).pipe(
      tap(([isRsaUser, isEndUserWithoutAccess]) => {
        if (isEndUserWithoutAccess) {
          this.router.navigate(['/access-forbidden']);
        } else if (!isRsaUser) {
          this.router.navigate(['/dashboard']);
        } else {
          this.router.navigate(['/search']);
        }
      }),
      map(([isRsaUser]) => isRsaUser)
    );

    const notAuthenticated$ = of(true);

    return this.authStore.state$.pipe(
      mergeMap((state) =>
        iif(() => state.authenticated && state.authorized, authenticated$, notAuthenticated$)
      )
    );
  }
}
